import React, { createContext, useContext, useMemo, useReducer } from 'react';

export const dropdownActionTypes = {
  open: 'open',
  close: 'close',
  toggle: 'toggle',
};

const DropdownStateContext = createContext(null);
const initialState = {
  dropdown: dropdownActionTypes.close,
  menuType: null,
};

function reducer(state, action) {
  switch (action.type) {
    case dropdownActionTypes.open:
      return {
        dropdown: dropdownActionTypes.open,
        menuType: action.menuType,
      };
    case dropdownActionTypes.close:
      return {
        dropdown: dropdownActionTypes.close,
        menuType: action.menuType,
      };
    case dropdownActionTypes.toggle:
      return {
        dropdown: state.dropdown === dropdownActionTypes.open ? dropdownActionTypes.close : dropdownActionTypes.open,
        menuType: action.menuType,
      };
    default:
      console.log('DropdownStateContext', state, action);
      throw new Error('Unknown dropdown action type provided');
  }
}

export function NavigationDropdownStateProvider({ children }) {
  const [dropdownState, dispatchDropdownState] = useReducer(reducer, initialState);

  let contextValue = useMemo(() => {
    return { dropdownState, dispatchDropdownState };
  }, [dropdownState]);

  return <DropdownStateContext.Provider value={contextValue}>{children}</DropdownStateContext.Provider>;
}

export function useDropdownState() {
  return useContext(DropdownStateContext);
}
